/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_SubscriptionsInputs */

const en_settings_billing_subscriptions = /** @type {(inputs: Settings_Billing_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriptions`)
};

const zh_settings_billing_subscriptions = /** @type {(inputs: Settings_Billing_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅列表`)
};

/**
* | output |
* | --- |
* | "Subscriptions" |
*
* @param {Settings_Billing_SubscriptionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_subscriptions = /** @type {((inputs?: Settings_Billing_SubscriptionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_SubscriptionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_subscriptions(inputs)
	return zh_settings_billing_subscriptions(inputs)
});
export { settings_billing_subscriptions as "settings.billing.subscriptions" }